/* less/lib/less/tree/variable-call */ function _(require, module, exports) {
    var Node = require(232) /* ./node */, Variable = require(244) /* ./variable */, Ruleset = require(237) /* ./ruleset */, DetachedRuleset = require(217) /* ./detached-ruleset */, LessError = require(194) /* ../less-error */;
    var VariableCall = function (variable, index, currentFileInfo) {
        this.variable = variable;
        this._index = index;
        this._fileInfo = currentFileInfo;
        this.allowRoot = true;
    };
    VariableCall.prototype = new Node();
    VariableCall.prototype.type = 'VariableCall';
    VariableCall.prototype.eval = function (context) {
        var rules, detachedRuleset = new Variable(this.variable, this.getIndex(), this.fileInfo()).eval(context), error = new LessError({ message: 'Could not evaluate variable call ' + this.variable });
        if (!detachedRuleset.ruleset) {
            if (detachedRuleset.rules) {
                rules = detachedRuleset;
            }
            else if (Array.isArray(detachedRuleset)) {
                rules = new Ruleset('', detachedRuleset);
            }
            else if (Array.isArray(detachedRuleset.value)) {
                rules = new Ruleset('', detachedRuleset.value);
            }
            else {
                throw error;
            }
            detachedRuleset = new DetachedRuleset(rules);
        }
        if (detachedRuleset.ruleset) {
            return detachedRuleset.callEval(context);
        }
        throw error;
    };
    module.exports = VariableCall;
}
